import { Progress } from 'antd';
import React from 'react';
import ReactDOM from 'react-dom';
import './PlotRadial.css';

// Import the MAX_BOOKINGS_PER_DAY constant from DateCarousel
const MAX_BOOKINGS_PER_DAY = 50;

const PlotRadial = ({ dateBookings = [], maxBookingsPerDay = MAX_BOOKINGS_PER_DAY }) => {
  const totalBookings = dateBookings.length;
  
  // Calculate percentage, capped at 100% if exceeding MAX_BOOKINGS_PER_DAY
  const percent = Math.min((totalBookings / maxBookingsPerDay) * 100, 100);
  
  const getColor = () => {
    // Use percentage-based thresholds
    // Low = more than 80% availability (less than 20% filled)
    // High = less than 20% availability (more than 80% filled)
    // Medium = anything in between
    
    if (percent > 80) {
      // High booking density (less than 20% availability)
      return '#FF4D4F';
    } else if (percent < 20) {
      // Low booking density (more than 80% availability)
      return '#51B238';
    } else {
      // Medium booking density
      return '#FAAD14';
    }
  };

  return (
    <div className='plot-radial-wrap'>
      <Progress
        type="circle"
        percent={percent}
        strokeColor={getColor()}
        trailColor="#ECECEC"
        width={80}
        format={() => ''}
      />
    </div>
  );
};

export default React.memo(PlotRadial)